import PropTypes from 'prop-types';

import styles from './WineCriticSlide.module.scss';

const WineCriticSlide = ({ rating }) => (
  <div className={styles.container} data-test-id="wine-critic-slide" data-rbf="wine-critic-slide">
    {rating.logo && <img src={rating.logo} alt={rating.name} loading="lazy" />}
    <span className={styles.name} data-test-id="wine-critic-slide-name" >{rating.name}</span>
    <span className={styles.rating} data-test-id="wine-critic-slide-value" >{`${rating.value}/${rating.ratingMax}`}</span>
  </div>
);

WineCriticSlide.propTypes = {
  rating: PropTypes.object.isRequired
};

export default WineCriticSlide;
